module.exports = __webpack_public_path__ + "static/media/FuturaBTMedium.a7715dc5.woff";